import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cac37d04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-fullwidth navbar-menu" }
const _hoisted_2 = { class: "navbar-start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon fa-lg fas fa-home mb-1" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "force-dropdown-styling is-boxed is-flex is-flex-direction-column is-align-items-center navbar-dropdown" }
const _hoisted_6 = {
  class: "force-dropdown-styling is-boxed navbar-dropdown",
  style: { 'height': '150px' }
}
const _hoisted_7 = { class: "force-dropdown-styling is-boxed navbar-dropdown" }
const _hoisted_8 = { class: "gapped-options is-flex is-flex-direction-row" }
const _hoisted_9 = { class: "force-dropdown-styling is-boxed navbar-dropdown" }
const _hoisted_10 = { class: "gapped-options is-flex is-flex-direction-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider m-2" }, null, -1))
const _hoisted_12 = { class: "gapped-options is-flex is-flex-direction-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon fa-lg fas fa-search-plus mb-1" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon fa-lg fas fa-search-minus mb-1" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

import {
  CuttingPlaneType,
  getRawValue,
  HoopsDrawModeOptions,
  HoopsOrientationAndProjectionOptions,
  HoopsPerspective,
  HoopsSlice,
  HoopsSliceOptions,
  HoopsToolbarIcon,
} from '@/plugins/hoops'
import { computed, ref } from 'vue'
import { CuttingPlaneState } from '@/store/modules/hoopsWebViewer'
import SliderInput from '@/components/common/SliderInput.vue'
import { useStore } from 'vuex'

import DrawMode = Communicator.DrawMode

export default /*#__PURE__*/_defineComponent({
  __name: 'BottomToolbar',
  props: {
  disabled: Boolean
},
  setup(__props) {

const props = __props

const store = useStore()

const currentDrawMode = computed(() => {
  return store.getters['hoopsWebViewer/currentDrawMode']
})
const currentExplodeMagnitude = computed({
  get () {
    return store.getters['hoopsWebViewer/currentExplodeMagnitude']
  },
  set (newMagnitude: number) {
    store.dispatch('hoopsWebViewer/changeExplodeMagnitude', newMagnitude)
  }
})
const currentProjection = computed(() => {
  return store.getters['hoopsWebViewer/currentProjection']
})
const currentOrientation = computed(() => {
  return store.getters['hoopsWebViewer/currentOrientation']
})

const changeDrawMode = (mode: DrawMode) => {
  store.dispatch('hoopsWebViewer/changeDrawMode', mode)
}
const changePerspective = (projection: HoopsPerspective) => {
  store.dispatch('hoopsWebViewer/changePerspective', projection)
}
const changeSliceMode = (option: HoopsSlice) => {
  switch (option.type) {
    case CuttingPlaneType.PLANE_SECTION:
      store.dispatch('hoopsWebViewer/toggleCuttingPlaneSection')
      break
    case CuttingPlaneType.PLANE_VISIBILITY:
      store.dispatch('hoopsWebViewer/toggleCuttingPlaneVisibility')
      break
    case CuttingPlaneType.PLANE_X:
      store.dispatch('hoopsWebViewer/toggleCuttingPlaneX')
      break
    case CuttingPlaneType.PLANE_Y:
      store.dispatch('hoopsWebViewer/toggleCuttingPlaneY')
      break
    case CuttingPlaneType.PLANE_Z:
      store.dispatch('hoopsWebViewer/toggleCuttingPlaneZ')
      break
    case CuttingPlaneType.RESET:
      store.dispatch('hoopsWebViewer/removeAllCuttingPlanes')
      break
    default:
    // CuttingPlaneType.PLANE_FACE is unused for part
  }
}
const resetCameraView = () => {
  store.dispatch('hoopsWebViewer/resetCameraView')
}
const zoomIn = () => {
  store.dispatch('hoopsWebViewer/zoomIn')
}
const zoomOut = () => {
  store.dispatch('hoopsWebViewer/zoomOut')
}

/*
 * Explode requires special handling. Dragging the slider locks the menu open.
 * Hence, this requires programmatic handling.
 */
const explodeActive = ref(false)
const explodeHovering = () => explodeActive.value = !props.disabled
const explodeLeave = () => explodeActive.value = false

/**
 * Slice options can have two-states and three-states. :|
 * @param option
 */
const getSliceStyleClass = (option: HoopsSlice) => {
  function getClassForThreeState (state: CuttingPlaneState) {
    switch (state) {
      case CuttingPlaneState.OFF:
        return null
      case CuttingPlaneState.POSITIVE:
        return 'has-background-primary'
      case CuttingPlaneState.NEGATIVE:
        return 'has-background-primary-dark'
    }
  }

  switch (option.type) {
    case CuttingPlaneType.PLANE_SECTION:
      return store.getters['hoopsWebViewer/cuttingPlaneSectionEnabled'] ?
        'has-background-primary' : null
    case CuttingPlaneType.PLANE_VISIBILITY:
      return store.getters['hoopsWebViewer/cuttingPlaneVisibilityEnabled'] ?
        'has-background-primary' : null
    case CuttingPlaneType.PLANE_X:
      return getClassForThreeState(store.getters['hoopsWebViewer/cuttingPlaneXState'])
    case CuttingPlaneType.PLANE_Y:
      return getClassForThreeState(store.getters['hoopsWebViewer/cuttingPlaneYState'])
    case CuttingPlaneType.PLANE_Z:
      return getClassForThreeState(store.getters['hoopsWebViewer/cuttingPlaneZState'])
    case CuttingPlaneType.RESET:
      return // No color classes for RESET
    default:
      // PLANE_FACE is unused for part
  }
}

const isDisabledSliceOption = (option: HoopsSlice) => {
  switch (option.type) {
    case CuttingPlaneType.PLANE_SECTION:
      return store.getters['hoopsWebViewer/cuttingPlanesCount'] < 2 ? true : null
    case CuttingPlaneType.PLANE_VISIBILITY:
    case CuttingPlaneType.RESET:
      return store.getters['hoopsWebViewer/cuttingPlanesCount'] === 0 ? true : null
    default:
      return null // PLANE_FACE is unused for part
  }
}

return (_ctx: any,_cache: any) => {
  const _component_b_tooltip = _resolveComponent("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: _normalizeClass(["is-arrowless navbar-item normal-icon", { 'disabled': __props.disabled }]),
        onClick: resetCameraView
      }, _hoisted_4, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["hoops-icon navbar-item", { 'has-dropdown-up': !__props.disabled, 'is-hoverable': !__props.disabled }])
      }, [
        _createElementVNode("a", {
          class: _normalizeClass(["is-arrowless navbar-link", { 'custom-disabled': __props.disabled }])
        }, [
          _createVNode(_unref(HoopsToolbarIcon), { type: "wireframeshaded" })
        ], 2),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HoopsDrawModeOptions), (option) => {
            return (_openBlock(), _createBlock(_component_b_tooltip, {
              key: `${option.iconType}-${currentDrawMode.value}`,
              position: "is-right",
              delay: 500,
              label: _ctx.$t(`${option.labelKey}`)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(HoopsToolbarIcon), {
                  class: _normalizeClass(["gapped-options navbar-item", { 'has-background-primary': currentDrawMode.value === option.value }]),
                  type: `${option.iconType}`,
                  onClick: ($event: any) => (changeDrawMode(option.value))
                }, null, 8, ["class", "type", "onClick"])
              ], undefined, true),
              _: 2
            }, 1032, ["label"]))
          }), 128))
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["hoops-icon navbar-item hoops-icon", { 'has-dropdown-up': !__props.disabled, 'is-active': explodeActive.value }]),
        onMouseover: explodeHovering,
        onMouseleave: explodeLeave
      }, [
        _createElementVNode("a", {
          class: _normalizeClass(["is-arrowless navbar-link", { 'custom-disabled': __props.disabled }])
        }, [
          _createVNode(_unref(HoopsToolbarIcon), { type: "explode" })
        ], 2),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(SliderInput, {
            modelValue: currentExplodeMagnitude.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentExplodeMagnitude).value = $event)),
            class: "py-2",
            "is-vertical": ""
          }, null, 8, ["modelValue"])
        ])
      ], 34),
      _createElementVNode("div", {
        class: _normalizeClass(["hoops-icon navbar-item", { 'has-dropdown-up': !__props.disabled, 'is-hoverable': !__props.disabled }])
      }, [
        _createElementVNode("a", {
          class: _normalizeClass(["is-arrowless navbar-link", { 'custom-disabled': __props.disabled }])
        }, [
          _createVNode(_unref(HoopsToolbarIcon), { type: "cuttingplane" })
        ], 2),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HoopsSliceOptions), (optionRow) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionRow, (option) => {
                return (_openBlock(), _createBlock(_component_b_tooltip, {
                  position: "is-right",
                  delay: 500,
                  label: _ctx.$t(`${option.labelKey}`)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(HoopsToolbarIcon), {
                      class: _normalizeClass(["navbar-item", getSliceStyleClass(option)]),
                      disabled: isDisabledSliceOption(option),
                      id: `${option.elementId}`,
                      type: `${option.iconType}`,
                      onClick: ($event: any) => (isDisabledSliceOption(option) ? null : changeSliceMode(option))
                    }, null, 8, ["class", "disabled", "id", "type", "onClick"])
                  ], undefined, true),
                  _: 2
                }, 1032, ["label"]))
              }), 256))
            ]))
          }), 256))
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["hoops-icon navbar-item", { 'has-dropdown-up': !__props.disabled, 'is-hoverable': !__props.disabled }])
      }, [
        _createElementVNode("a", {
          class: _normalizeClass(["is-arrowless navbar-link", { 'custom-disabled': __props.disabled }])
        }, [
          _createVNode(_unref(HoopsToolbarIcon), { type: "camera" })
        ], 2),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HoopsOrientationAndProjectionOptions).get('projection'), (projectionRow) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectionRow, (projectionOption) => {
                return (_openBlock(), _createBlock(_component_b_tooltip, {
                  position: "is-right",
                  delay: 500,
                  label: _ctx.$t(`${projectionOption.labelKey}`)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(HoopsToolbarIcon), {
                      class: _normalizeClass(["navbar-item", { 'has-background-primary': [currentProjection.value, currentOrientation.value].includes(_unref(getRawValue)(projectionOption)) }]),
                      type: `${projectionOption.iconType}`,
                      onClick: ($event: any) => (changePerspective(projectionOption))
                    }, null, 8, ["class", "type", "onClick"])
                  ], undefined, true),
                  _: 2
                }, 1032, ["label"]))
              }), 256))
            ]))
          }), 256)),
          _hoisted_11,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HoopsOrientationAndProjectionOptions).get('orientation'), (orientationRow) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orientationRow, (orientationOption) => {
                return (_openBlock(), _createBlock(_component_b_tooltip, {
                  position: "is-right",
                  delay: 500,
                  label: _ctx.$t(`${orientationOption.labelKey}`)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(HoopsToolbarIcon), {
                      class: _normalizeClass(["navbar-item", { 'has-background-primary': [currentProjection.value, currentOrientation.value].includes(_unref(getRawValue)(orientationOption)) }]),
                      type: `${orientationOption.iconType}`,
                      onClick: ($event: any) => (changePerspective(orientationOption))
                    }, null, 8, ["class", "type", "onClick"])
                  ], undefined, true),
                  _: 2
                }, 1032, ["label"]))
              }), 256))
            ]))
          }), 256))
        ])
      ], 2),
      _createElementVNode("a", {
        class: _normalizeClass(["force-item-size navbar-item normal-icon", { 'disabled': __props.disabled }]),
        onClick: zoomIn
      }, _hoisted_14, 2),
      _createElementVNode("a", {
        class: _normalizeClass(["force-item-size navbar-item normal-icon", { 'disabled': __props.disabled }]),
        onClick: zoomOut
      }, _hoisted_16, 2)
    ])
  ]))
}
}

})